import { render, staticRenderFns } from "./qaItem3.vue?vue&type=template&id=787f717e&"
import script from "./qaItem3.vue?vue&type=script&lang=js&"
export * from "./qaItem3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('787f717e')) {
      api.createRecord('787f717e', component.options)
    } else {
      api.reload('787f717e', component.options)
    }
    module.hot.accept("./qaItem3.vue?vue&type=template&id=787f717e&", function () {
      api.rerender('787f717e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_home/qaItem3.vue"
export default component.exports